<template>
  <div class="topup-codes">
    <topup-codes-breadcrumbs/>
    <topup-codes-step1 v-if="isCurrentStep(1)" />
    <topup-codes-step2 v-if="isCurrentStep(2)" />
    <topup-codes-step3 v-if="isCurrentStep(3)" />
  </div>
</template>

<script>
import ProgressMixin from '@/common/mixins/Voucher/Progress.mixin'
import TopupCodesBreadcrumbs from '@/doladujtutaj/components/TopupCodes/Breadcrumbs'
import TopupCodesStep1 from '@/doladujtutaj/components/TopupCodes/Step1'
import TopupCodesStep2 from '@/doladujtutaj/components/TopupCodes/Step2'
import TopupCodesStep3 from '@/doladujtutaj/components/TopupCodes/Step3'
import { ToolsClass } from '@/common/class/tools.class'

export default {
  name: 'TopupCodesView',
  mixins: [ProgressMixin],
  components: {
    TopupCodesStep3,
    TopupCodesStep2,
    TopupCodesStep1,
    TopupCodesBreadcrumbs
  },
  mounted () {
    ToolsClass.sendHeightToIframeParent()
    window.addEventListener('resize', ToolsClass.sendHeightToIframeParent)
  },
  updated () {
    ToolsClass.sendHeightToIframeParent()
  }
}
</script>
